<template>
  <div class="tw-relative">
    <img
      src="../../../assets/images/gradient-rainbow-background.png"
      class="tw-pointer-events-none tw-absolute tw-z-0 tw-h-screen tw-w-full"
      alt=""
    />
    <div class="tw-relative tw-mx-auto tw-max-w-xl tw-p-8">
      <a href="https://growthmentor.com" target="_blank">
        <img
          src="../../../assets/images/growthmentor-logo.png"
          alt="GrowthMentor logo"
          class="tw-mx-auto tw-w-40"
        />
      </a>
      <div class="tw-mt-8 tw-rounded-md tw-bg-white tw-p-8 tw-shadow-xxl">
        <h1 class="tw-heading-1">Forgot password?</h1>
        <form @submit.prevent="submit" class="tw-mt-4 tw-space-y-6">
          <FormInput
            v-model="form.user.email"
            type="email"
            autocomplete="email"
            :is-error="Boolean(form.errors.email)"
            :errors="form.errors.email"
            @input="form.clearErrors('email')"
          >
            <template #label>Email</template>
          </FormInput>
          <div class="tw-flex tw-items-center tw-space-x-4">
            <BaseButton
              type="button"
              color="gray"
              is-block
              :is-rounded="false"
              size="large"
              class="tw-rounded-lg"
              is-interia-link
              href="/users/sign_in"
            >
              Go back
            </BaseButton>
            <BaseButton
              type="submit"
              color="purple"
              is-block
              :is-rounded="false"
              size="large"
              class="tw-rounded-lg tw-shadow-md"
            >
              Reset password
            </BaseButton>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import FormInput from '@/shared/components/forms/FormInput.vue'
import BaseButton from '@/shared/components/BaseButton.vue'
import { useForm } from '@inertiajs/vue3'
import { notify } from '@kyvg/vue3-notification'

const form = useForm({
  user: {
    email: '',
  },
})

const submit = () => {
  form.post('/users/password', {
    onFinish: () => {
      notify({
        type: 'success',
        text: 'If you provide registered email you will get instructions on how to reset your password.',
      })
    },
  })
}
</script>

<script>
import AuthLayout from '@/layouts/AuthLayout.vue'

export default {
  layout: AuthLayout,
}
</script>
